import { request } from '@/util/http'

export const getList = (current, size, params) => {
  return request({
    url: '/health/bpDrug/getList',
    method: 'get',
    params: {
      ...params,
      current,
      size
    }
  })
}

export const getDetail = (id) => {
  return request({
    url: '/health/bpDrug/detail',
    method: 'get',
    params: {
      id
    }
  })
}

export const remove = (ids) => {
  return request({
    url: '/health/bpDrug/remove',
    method: 'post',
    params: {
      ids
    }
  })
}

export const submit = (row) => {
  return request({
    url: '/health/bpDrug/submit',
    method: 'post',
    data: row
  })
}

export const getBpDurg = (id) => {
  return request({
    url: '/health/bpDrug/detail',
    method: 'get',
    params: {
      id
    }
  })
}
